import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import type { IniciativaItem } from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface PageBrain {
  Title?: string;
  Description?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Conteúdo, herda título e descrição.
 *
 * Só preenche campo vazio — mesma política de `Destaques/adapter.ts`. Depois
 * que o editor escreveu algo, trocar o destino não apaga o trabalho manual;
 * para o preenchimento voltar a rodar, basta limpar o campo.
 *
 * A imagem não entra: no card ela é fundo de um véu colorido, sempre arte
 * dedicada (ver `getIniciativaImageProps`).
 */
export const buildIniciativaFields = (
  page: PageBrain,
  item: IniciativaItem = {},
): Partial<IniciativaItem> => {
  const patch: Partial<IniciativaItem> = {};
  if (!item.title && page.Title) patch.title = page.Title;
  if (!item.description && page.Description)
    patch.description = page.Description;
  return patch;
};

export const IniciativasBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildIniciativaFields,
  );
};

export default IniciativasBlockDataAdapter;
